import { mixed } from 'yup'

import { TournamentField } from '../../types'
import { TournamentRewardMap } from '../constants/TournamentReward'
import { typeTransform } from './utils'

export const rewardTypeSchema = mixed<TournamentField>().required().transform(typeTransform(TournamentRewardMap))
